export default {
    "title": "BIOMEMS & NANOBIO SYSTEM",
    "content": "本實驗室主要是進行生醫感測器(血液檢測與呼氣檢測)、食品安全檢測晶片、奈米線、仿生電子抗體、次世代DNA定序研發與系統整合, 以及相關所衍生奈米科技、生醫 電子、智慧型高分子之基礎科學現象探討",
    "list": [{
        "research":"生醫感測器及微系統整合",
        "discribe":"生醫電子感測器、光電奈米線感測器、 壓電聲波微發送器、 非侵入式呼氣疾病檢測系統、 多通道生醫感測系統、Android人機介面、 定點照護(point-of-care)之可攜式(portable)或手持式(handheld)嵌入式感測平台"
    },{
        "research":"仿生高分子技術與微流體技術",
        "discribe":"仿生真空吸引模組、仿生分子拓印電子抗體、微流體液滴操控、 乳化液滴高分子製程、多通道微流體操控 、高效能全血血漿分離元件"
    },{
        "research":"奈米科技與生醫奈米",
        "discribe":"噴印與滾印製程、尖端奈米元件與製程、奈米生物電子元件、混成奈米線、 DNA生物電子定序元件、混成高分子奈米發電元件"
    }]
}